import {useState} from 'react';
import PropTypes from 'prop-types';

export default function LoginScreen({onLogin, verifiedStatus, resetStatus}) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    async function handleSubmit(e) {
        e.preventDefault();
        setError('');
        try {
            const res = await fetch('/auth/login', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({email, password}),
            });
            if (res.status === 403) {
                setError('Please verify your email before signing in.');
                return;
            }
            if (!res.ok) {
                setError('Invalid email or password');
                return;
            }
            const data = await res.json();
            onLogin(data.token, data.username, data.userID);
        } catch {
            setError('Login failed. Please try again.');
        }
    }

    return (
        <div className="login-screen">
            <form className="login-form" onSubmit={handleSubmit}>
                <h2 className="login-title">Sign in</h2>
                {verifiedStatus === 'success' ? (
                    <p className="login-success">Email verified! You can now sign in.</p>
                ) : verifiedStatus === 'error' ? (
                    <p className="login-error">Invalid or expired verification link.</p>
                ) : resetStatus === 'success' ? (
                    <p className="login-success">Password reset! You can now sign in.</p>
                ) : null}
                {error ? <p className="login-error">{error}</p> : null}
                <input
                    className="login-input"
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    autoFocus
                />
                <input
                    className="login-input"
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                />
                <button
                    className="login-button"
                    type="submit"
                    disabled={!email || !password}
                >Sign in</button>
                <p className="login-register-link">
                    New here? <a href="/?register">Create an account</a>
                </p>
                <p className="login-register-link">
                    Forgot your password? <a href="/?forgot-password">Reset it</a>
                </p>
            </form>
        </div>
    );
}

LoginScreen.propTypes = {
    onLogin: PropTypes.func.isRequired,
    verifiedStatus: PropTypes.string,
    resetStatus: PropTypes.string,
};
